import { getElements } from '@by-association-only/theme-utils';
const defaultSchema = {
  moduleAttribute: 'data-module',
  externalElAttribute: 'data-external-el',
  elAttribute: 'data-el'
};
export class Application {
  static start(element, schema) {
    const application = new Application(element, schema);
    application.start();
    return application;
  }

  constructor(element = document.documentElement, schema = defaultSchema) {
    this.modules = [];
    this.element = element;
    this.schema = schema;
  }

  async start() {
    await domReady();
    getElements(`[${this.schema.moduleAttribute}]`).forEach(el => {
      const isLazy = el.hasAttribute('data-module-lazy');
      if (isLazy) return;
      return this.startModule(el, el.getAttribute(this.schema.moduleAttribute));
    });
  }

  startModule(el, name) {
    return import(
    /* webpackChunkName: "[request]" */
    `../${name}`).then(({
      default: Module
    }) => {
      const module = Module.build(el, this);
      this.modules.push(module);
      return module;
    });
  }

  stopModule(el) {
    const module = this.modules.find(module => module.element === el);
    if (!module) return;
    module.destroy();
    this.modules = this.modules.filter(m => m.element !== module.element);
  }

  registerModule(el) {
    return this.startModule(el, el.getAttribute(this.schema.moduleAttribute));
  }

  reinitialiseModules(el) {
    getElements(`[data-module]`, {
      context: el
    }).forEach(el => this.registerModule(el));
  }

  destroyModules(el) {
    getElements(`[data-module]`, {
      context: el
    }).forEach(el => this.stopModule(el));
  }

}

function domReady() {
  return new Promise(resolve => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', resolve);
    } else {
      resolve();
    }
  });
}